﻿import { BaseResponse } from './base-response.model';

export class GetPaymentStatusResponse extends BaseResponse {
    public paymentFinished: boolean;
    public checkAgain: boolean;
}